import axios from 'axios';
import { csrfToken } from '@rails/ujs';

export default class SubmitBtn {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;

    this.node.addEventListener('click', (e) => {
      e.preventDefault();
      if (!this.app.getState('firstSubmit')) this.app.setState('firstSubmit', true);

      const requestURI = `${this.store.config.aicAPIBaseURI}?${this.app.getQueries()}`;

      // [note] まずリクエスト開始前にローディングぐるぐるパーツを表示します。
      this.app.setState('isFetching', true);

      axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
      axios.interceptors.request
        .use(config => ({ ...config, headers: { ...config.headers, 'X-CSRF-Token': csrfToken() } }));

      // [note] リクエストしています
      axios
        .get(requestURI)
        .then((res) => {
          // [note] 結果タグ(html)を表示に追加する
          const result = document.getElementById('aic_search_result');
          result.innerHTML = res.data;

          // 結果部分にスクロール
          this.app.aiRoutePlannerSubmitBtnScroller.scroll();

          // [note] ローディングダイアログを停止します。
          this.app.setState('isFetching', false);
        })
        .catch((err) => {
          console.log(err.response); // eslint-disable-line no-console
          // [note] ローディングダイアログを停止します。
          this.app.setState('isFetching', false);
          return null;
        });
    });
  }
}
